import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JS Modules
import ShallowComparatorMixin from '../../_utils/shallow-comparator-mixin';

// -----------------------------------------------------------
//  PrintsBuilderApp.UploadProgressBar
// -----------------------------------------------------------
var UploadProgressBar = createReactClass({
  mixins: [ShallowComparatorMixin],
  render() {
    if (!this.props.total) {
      return null;
    }

    const index = Math.min(this.props.index + 1, this.props.total),
          percent = Math.min(Math.round((index / this.props.total) * 100), 100);

    const $body = (() => {
      if (this.props.paused) {
        return <span>Paused</span>;
      }

      return <span>Uploading {index} of {this.props.total}</span>;
    })();

    return (
      <div className="progress-bar__container" data-test="upload-progress">
        <div className="progress">
          <div role="progressbar"
            className={classNames('progress-bar text-left', { 'bg-success ': !this.props.paused, 'bg-warning': this.props.paused })}
            aria-valuenow={percent}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: percent + '%' }}>
            {$body}
          </div>
        </div>
      </div>
    );
  }
});

export default UploadProgressBar;
